<div class="profile-image-with-progres">
  <div
    class="circle-contianer"
    [style.width.px]="dimensions.width"
    [style.height.px]="dimensions.height"
  >
    <div class="edit-profile-image" *ngIf="isLoading">
      <div class="three-quarter-spinner"></div>
    </div>
    <label for="profileImage" class="edit-profile-image"><i class="fas fa-edit inner-icon"></i></label>
    <input
      id="profileImage"
      class="form-control d-none"
      type="file"
      accept="image/*"
      (change)="changeSelection($event)"
    />
    <div
      class="profile-image"
      *ngIf="imgUrl"
      [style]="getProfileImageStyles()"
    ></div>
    <div class="profile-image profile-name" *ngIf="!imgUrl">
      <span class="name">{{getShortName(fullName)}}</span>
    </div>
  </div>
</div>
